import React from 'react';

import { DetectionReport } from './types';

const FigureCard = ({ figure }: { figure: DetectionReport['figures']['placed'][number] }) => (
  <li className="tw-rounded tw-border tw-border-solid tw-border-spa-border tw-px-3 tw-py-2">
    <p className="tw-m-0 tw-font-mono tw-text-sm tw-font-bold tw-text-spa-heading">
      {figure.asset || 'Unnamed image (pasted, not linked)'}
    </p>
    <p className="tw-m-0 tw-mt-0.5 tw-text-xs tw-text-spa-secondary">
      {figure.sectionTitle}{figure.caption ? ` — “${figure.caption}”` : ' — no caption paired'}
    </p>
  </li>
);

// The images the print places near reading sections (paired to captions by page geometry), so a
// human can check the pairing before trusting caption diffs and pour placeholders.
const FiguresPanel = ({ figures }: { figures: DetectionReport['figures'] }) => (
  <div className="tw-mt-3">
    {figures.placed.length === 0 ? (
      <p className="tw-m-0 tw-text-sm tw-text-spa-secondary">No images detected near reading sections.</p>
    ) : (
      <ul className="tw-flex tw-list-none tw-flex-col tw-gap-2 tw-p-0">
        {figures.placed.map(figure => (
          <FigureCard key={`${figure.sectionTitle}-${figure.asset}`} figure={figure} />
        ))}
      </ul>
    )}
    {figures.otherFrames > 0 && (
      <p className="tw-m-0 tw-mt-2 tw-text-xs tw-text-spa-secondary">
        {figures.otherFrames} more image{figures.otherFrames === 1 ? '' : 's'} sit near non-reading
        frames (activities, map art) and aren’t poured.
      </p>
    )}
  </div>
);

export default FiguresPanel;
